import { PROD_API_BASE_URL } from '@config/api'

let tauriFetchPromise = null

export function isTauriRuntime() {
  if (typeof window === 'undefined') return false
  return Boolean(
    window.__TAURI_INTERNALS__ ||
    window.__TAURI__ ||
    window.location.hostname === 'tauri.localhost'
  )
}

function resolveRequestUrl(input) {
  if (typeof input !== 'string') return input
  if (/^https?:\/\//i.test(input)) return input
  if (isTauriRuntime() && input.startsWith('/')) {
    return `${PROD_API_BASE_URL}${input}`
  }
  return input
}

async function resolveFetch() {
  if (!isTauriRuntime()) {
    return window.fetch.bind(window)
  }

  if (!tauriFetchPromise) {
    tauriFetchPromise = import('@tauri-apps/plugin-http').then((mod) => mod.fetch)
  }

  return tauriFetchPromise
}

/**
 * Unified fetch: browser fetch in web, Tauri native HTTP in desktop (bypasses CORS).
 */
export async function httpFetch(input, init) {
  const fetchFn = await resolveFetch()
  const url = resolveRequestUrl(input)
  return fetchFn(url, init)
}
